var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerifyMessage(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 38,
    viewBox: "0 0 40 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 13.5833C40 11.282 38.1333 9.41663 35.8333 9.41663C28.5792 9.41663 11.4208 9.41663 4.16667 9.41663C1.86667 9.41663 0 11.282 0 13.5833V33.5833C0 35.8845 1.86667 37.75 4.16667 37.75H35.8333C38.1333 37.75 40 35.8845 40 33.5833C40 28.46 40 18.7066 40 13.5833Z",
    fill: "#9AEBA3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 17.277L18.6 29.8225C19.4458 30.3925 20.5542 30.3925 21.4 29.8225L40 17.277V13.5833C40 11.282 38.1333 9.41663 35.8333 9.41663C28.5792 9.41663 11.4208 9.41663 4.16667 9.41663C1.86667 9.41663 0 11.282 0 13.5833V17.277Z",
    fill: "#8BE495"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 33.1762C40 32.8991 39.8625 32.6404 39.6334 32.4854L20.4667 19.5591C20.1834 19.3691 19.8166 19.3691 19.5333 19.5591L0.366618 32.4854C0.137451 32.6404 0 32.8991 0 33.1762V33.5833C0 35.8845 1.86667 37.75 4.16667 37.75H35.8333C38.1333 37.75 40 35.8845 40 33.5833V33.1762Z",
    fill: "#81E48C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4583 25.005L18.5999 29.8225C19.4458 30.3925 20.5542 30.3925 21.4 29.8225L28.5416 25.005L20.4667 19.5591C20.1834 19.3691 19.8166 19.3691 19.5333 19.5591L11.4583 25.005Z",
    fill: "#69DD76"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14.8237C0 15.1008 0.137451 15.3595 0.366618 15.5145L19.5333 28.4408C19.8166 28.6308 20.1834 28.6308 20.4667 28.4408L39.6334 15.5145C39.8625 15.3595 40 15.1008 40 14.8237V13.5833C40 11.282 38.1333 9.41663 35.8333 9.41663C28.5792 9.41663 11.4208 9.41663 4.16667 9.41663C1.86667 9.41663 0 11.282 0 13.5833V14.8237Z",
    fill: "#B9F1C0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.97915 9.41663H32.0209C32.0626 9.82746 32.0834 10.2445 32.0834 10.6666C32.0834 17.3358 26.6709 22.75 20 22.75C13.3292 22.75 7.91669 17.3358 7.91669 10.6666C7.91669 10.2445 7.93748 9.82746 7.97915 9.41663Z",
    fill: "#AAE9B1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20 21.0833C25.7529 21.0833 30.4166 16.4196 30.4166 10.6667C30.4166 4.9137 25.7529 0.25 20 0.25C14.247 0.25 9.58331 4.9137 9.58331 10.6667C9.58331 16.4196 14.247 21.0833 20 21.0833Z",
    fill: "#45C4B0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8292 7.16081L18.3333 13.655L14.7541 10.0775C14.4291 9.75206 13.9042 9.75206 13.5792 10.0775C13.2542 10.4025 13.2542 10.9308 13.5792 11.2558L17.7459 15.4225C18.0709 15.7479 18.5958 15.7479 18.9208 15.4225L26.0041 8.33915C26.3333 8.01415 26.3333 7.48581 26.0041 7.16081C25.6791 6.83539 25.1542 6.83539 24.8292 7.16081Z",
    fill: "#13678A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyMessage);
export default __webpack_public_path__ + "static/media/verify-message.c14b9d54d62e49f02c48cf53f8f24347.svg";
export { ForwardRef as ReactComponent };